import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/MarketPlace/TransportationService.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import arrowdown from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import blankStar from '../../../Assets/NominateRequest/starBlank_small.svg';
import filledStar from '../../../Assets/NominateRequest/starFilled_small.svg';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import UploadFile from '../../Shared/UploadFile';
import Button from '../../Shared/Button';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import CancelModal from '../../Shared/CancelModalMarketPlace';
import StarRatingModal from '../../Shared/StarRatingModal';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import bigBlankStar from '../../../Assets/NominateRequest/starBlank_large.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import bigFilledStar from '../../../Assets/NominateRequest/starFilled_large.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTS_ENDPOINT, SERVICE_REQUEST_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { connect } from 'react-redux';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
// Requester transportation services(toggle screen)
class TransportationService extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceRequestId: 0,
            quotationsReceivedData: [],
            serviceNameValue: '',
            search: "",
            searchlength: 0,
            datatemporary: [],
            statusSelectorValue: 'All',
            statusSelectorIDDropdown: false,
            statusSelectorID: [],
            noQuotationReceived: false,
            showQuotationReceived: true,
            showServiceDetails: false,
            showServiceDetailsWithoutCancelRequest: false,
            pickupLocation: '',
            destination: '',
            serviceWindowStartDateTime: "",
            serviceWindowEndDateTime: "",
            NoOfContainers: '',
            commodity: '',
            truckTypeRequirements: '',
            paymentTerms: '',
            RFQClosingDate: "",
            specialInstructions: "",
            loaderTime: false,
            PageDisable: false,
            FilePathTransportationServiceDeliveryDocuments: '',
            hasOpen: false,
            hasOpenRating: false,
            ratingStar: '',
            errorStarReason: "",
            reasonTextLimit: 0,
            errors: {},
            ApiServiceRequestData: [],
        }
        this.handlechangeSearchTransportationServiceID = this.handlechangeSearchTransportationServiceID.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { serviceId, serviceName } = this.props.match.params;
        this.setState({ serviceRequestId: serviceId, serviceNameValue: serviceName })
        this.getRequestDetails(serviceId);
    }
    getRequestDetails = (serviceId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {

            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                }
                else {
                    console.log('I am 200!');
                    this.setState({ ApiServiceRequestData: data }, () => {

                        console.log("ApiData", this.state.ApiServiceRequestData, FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.endDateTime).timedateToLocale);
                        this.setState({
                            pickupLocation: this.state.ApiServiceRequestData?.serviceRequestData?.pickup_location,
                            destination: this.state.ApiServiceRequestData?.serviceRequestData?.destination,
                            serviceWindowStartDateTime: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.startDateTime).timedateToLocale,
                            serviceWindowEndDateTime: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.endDateTime).timedateToLocale,
                            NoOfContainers: this.state.ApiServiceRequestData?.serviceRequestData?.container_size,
                            commodity: this.state.ApiServiceRequestData?.serviceRequestData?.commodity,
                            truckTypeRequirements: this.state.ApiServiceRequestData?.serviceRequestData?.truck_type_req,
                            paymentTerms: this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.paymentTerm,
                            RFQClosingDate: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.rfqDateTime).timedateToLocale,
                            specialInstructions: this.state.ApiServiceRequestData?.serviceRequestData?.special_instructions,
                            FilePathUpdateReferenceDocuments: this.state.ApiServiceRequestData?.serviceRequestData?.upload_documents
                        })
                    });
                    this.setState({ quotationsReceivedData: data })
                    if (!data?.respondents?.otherRespondents?.length) {
                        this.setState({ noQuotationReceived: true })
                    }
                }
            }
        });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ statusSelectorIDDropdown: false });
        }
    };
    statusSelectorID = [{ name: "All" }, { name: "Open" }, { name: "Accepted" }, { name: "Rejected" }, { name: "Cancelled" }]
    toggleDropdownstatusSelectorID = () => {
        this.setState({ statusSelectorIDDropdown: !this.state.statusSelectorIDDropdown });
    };
    changestatusSelectorID = (event) => {
        const found = this.statusSelectorID.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ statusSelectorValue: found.name });
        this.setState({ statusSelectorIDDropdown: !this.state.statusSelectorIDDropdown });
        if (found.name == 'Open') {
            const openFilter = this.state.quotationsReceivedData?.respondents?.otherRespondents.filter(i => i.quotationStatus == 'Open')
            console.log('abc--', openFilter)
            this.setState({
                datatemporary: openFilter
            })
        } else if (found.name == 'Accepted') {
            const acceptedFilter = this.state.quotationsReceivedData?.respondents?.otherRespondents.filter(i => i.quotationStatus == 'Accepted')
            console.log('abc----', acceptedFilter)
            this.setState({
                datatemporary: acceptedFilter
            })
        } else if (found.name == 'Rejected') {
            const rejectedFilter = this.state.quotationsReceivedData?.respondents?.otherRespondents.filter(i => i.quotationStatus == 'Rejected')
            console.log('abc----', rejectedFilter)
            this.setState({
                datatemporary: rejectedFilter
            })
        } else if (found.name == 'Cancelled') {
            const cancelledFilter = this.state.quotationsReceivedData?.respondents?.otherRespondents.filter(i => i.quotationStatus == 'Cancelled')
            console.log('abc----', cancelledFilter)
            this.setState({
                datatemporary: cancelledFilter
            })
        }
        else {
            this.setState({
                datatemporary: this.state.quotationsReceivedData?.respondents?.otherRespondents
            })
        }
    }
    handleCardDetails = (index) => {
        this.state.datatemporary.find((dataStorage) => {
            if (dataStorage.quotationId === this.state.datatemporary[index].quotationId) {
                console.log('abc---', dataStorage.quotationId);
                this.props.history.push({
                    pathname: `/QuotationDetails/${this.state.serviceRequestId}/${dataStorage.quotationId}/${dataStorage?.respondentId}/${this.state.serviceNameValue}/${dataStorage?.quotationStatus}`,
                    state: dataStorage
                });
            }
        })
    }
    handlechangeSearchTransportationServiceID = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length
        });
    };
    searchTransportationService = () => {
        if (this.state.searchlength > 0) {
            const datafilter = this.state.quotationsReceivedData?.respondents?.otherRespondents.filter(i => i.quotationId == this.state.search)
            this.setState({ datatemporary: datafilter });
            console.log("inside search function", this.state.datatemporary);
        }
    }
    showQuotationReceivedfunction = () => {
        this.setState({ showQuotationReceived: true, showServiceDetails: false });
    }
    showServiceDetailsfunction = () => {
        this.setState({ showQuotationReceived: false, showServiceDetails: true });
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeTransportationServiceDeliveryDocumentsLink = () => {
        let path = "";
        this.setState({ FilePathTransportationServiceDeliveryDocuments: path });
    }
    setLoaderTransportationServiceDeliveryDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkTransportationServiceDeliveryDocuments = (filePathURL) => {
        // for loader end
        this.setState({ FilePathTransportationServiceDeliveryDocuments: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    handleCompleteRequest = () => {
        this.setState({ hasOpenRating: true })
    }
    onYesModal = () => {
        ApiCall(
            'DELETE',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?serviceRequestNumber=${this.state.serviceRequestId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.setState({ hasOpen: false });
                    this.props.history.push(`/QuotationHistory`)
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    };
    onCloseModal = () => {
        this.setState({ hasOpen: false });
    };
    onCancelRequest = () => {
        this.setState({ hasOpen: true });
    };
    getContainerDetails = () => {
        this.props.history.push(`/ViewQuotationContainerDetails/${this.state.serviceRequestId}`)
    }
    updateRating = (index) => {
        this.setState({ ratingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    Comment: ''
                }
            });
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpenRating: false });
        }
    };
    handleValidationModel = () => {
        let errorStarReason = '';
        let errors = {};
        let formIsValid = true;
        if (this.state.hasOpenRating) {
            if (!this.state.ratingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
            if (!this.state.reason) {
                errors["Comment"] = Message.validation.required;
                formIsValid = false;
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }
    render() {
        if (this.state.searchlength == 0 && this.state.statusSelectorValue === 'All') {
            this.state.datatemporary = this.state.quotationsReceivedData?.respondents?.otherRespondents;
            console.log("inside render search", this.state.datatemporary);
        }
        let statusSelectorIDDropdownImage = this.state.statusSelectorIDDropdown ? <img src={arrowup} /> : <img src={arrowdown} />
        return (
            <div class="csOuterColorTransportationService">
                <MetaDecorator title={TitleDescription.TransportationServiceTitle} description={TitleDescription.TransportationServiceDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csNoFullTransportationService">
                    <div id="csNoBox1TransportationService">
                        <nav class="ccNoNoNavbarTransportationService">
                            <div className="ccNoNavbarNameTransportationService">
                                <small id="noNavcTransportationService">{this.state.serviceNameValue}</small>
                            </div>
                            {
                                this.state.showServiceDetails && !this.state.showServiceDetailsWithoutCancelRequest ?
                                    <div id="TransportationServiceNAcceptMobile"
                                        className="TransportationServiceNNavbarNameRight"
                                        onClick={this.onCancelRequest}
                                    >
                                        <img src={cancelicon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small id="TransportationServiceCancelRequest" >Cancel Request</small>
                                    </div>
                                    : null
                            }
                        </nav>
                        <hr class="hr1" />
                        {
                            this.state.showServiceDetails && !this.state.showServiceDetailsWithoutCancelRequest ?
                                <nav class="TransportationServiceNMobileNavbar">
                                    <div className="TransportationServiceNNavbarNameRight" onClick={this.onCancelRequest}>
                                        <img src={cancelicon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small id="TransportationServiceCancelRequest" >Cancel Request</small>
                                    </div>
                                </nav>
                                : null
                        }
                        <div class={this.state.showServiceDetails ? "TransportationServiceShowServiceDetailsButtonDiv" : "topPartButtonSectionTransportationServiceDiv"}>
                            <div class="topPartInnerButtonSectionTransportationServiceDiv">
                                <div class={this.state.showQuotationReceived ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showQuotationReceivedfunction}>
                                    <small class={this.state.showQuotationReceived ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>Response Received</small>
                                </div>
                                <div class={this.state.showServiceDetails ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showServiceDetailsfunction}>
                                    <small class={this.state.showServiceDetails ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>Request Details</small>
                                </div>
                            </div>
                        </div>
                        <div class={this.state.showServiceDetails ? "TransportationServiceShowServiceDetailsNav" : "notificationMainCardTransportationService"}>
                            {this.state.showQuotationReceived && this.state.noQuotationReceived ?
                                <div class="noQuotationReceivedTransportationServiceOuterDiv">
                                    <small class="TransportationServiceHeading">No response received.</small>
                                </div>
                                :
                                <div>
                                    {
                                        this.state.showQuotationReceived && !this.state.noQuotationReceived ?
                                            <div>
                                                <div class="conCsDivLow199TransportationService">
                                                    <div class="csDivLow2Pre1TransportationService">
                                                        <input
                                                            className="preSearchTransportationService"
                                                            placeholder="Search by Service Request ID"
                                                            autoComplete="off"
                                                            id="secrchInput1Pre11TransportationService"
                                                            onChange={this.handlechangeSearchTransportationServiceID}
                                                            value={this.state.search}
                                                        ></input>
                                                        <img onClick={this.searchTransportationService} id="searchPre_Img12TransportationService" src={searchimg} width="16" height="16" />
                                                    </div>
                                                    <div class="TransportationServiceTopDropDownDiv">
                                                        <div className="pass-wrapper" id="statusSelectorWrapperDiv" >
                                                            <Input
                                                                name="statusSelectorValue"
                                                                readOnly class="input"
                                                                type="text" id={this.state.statusSelectorIDDropdown ? "statusSelectorInputDropdownOpen" : "statusSelectorInputDropdown"} value={this.state.statusSelectorValue}
                                                            />
                                                            <i id="statusSelectorIButtonDropdown" onClick={this.toggleDropdownstatusSelectorID}>{statusSelectorIDDropdownImage}</i>
                                                        </div>
                                                        {this.state.statusSelectorIDDropdown && (
                                                            <div class="statusSelectorTableDropdown" >
                                                                <div class="statusSelectorTableContainer" ref={this.container} >
                                                                    {(this.statusSelectorID?.map((name, index) => {
                                                                        return (
                                                                            <DropDownTable onClick={(index1) => this.changestatusSelectorID(index1)}>
                                                                                <small class="pl-1" id="createRequestTableContent" >{name?.name} </small>
                                                                            </DropDownTable>
                                                                        );
                                                                    }))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div class="consDiv1TransportationService">
                                                    {(this.state.datatemporary?.map((datatemporary, index) => {
                                                        return (
                                                            <div class="outDivInsideTransportationService" onClick={() => this.handleCardDetails(index)}>
                                                                <div class="secondDivvTransportationService">
                                                                    <div class="outerTransportationServiceWholeDataDiv">
                                                                        <div class="TransportationServiceWholeDataWithArrowDiv">
                                                                            <div class="TransportationServiceWholeDataDiv">
                                                                                <div class="TransportationServiceRow1Div">
                                                                                    <div class="TransportationServiceContent1Div">
                                                                                        <small class="TransportationServiceHeading">Service Request ID</small>
                                                                                        <small class="TransportationServiceValues">{datatemporary?.quotationId}</small>
                                                                                    </div>
                                                                                    <div class="TransportationServiceContent1Div">
                                                                                        <small class="TransportationServiceHeading1TS">Company Name</small>
                                                                                        <small class="TransportationServiceValues">{datatemporary?.companyName}</small>
                                                                                    </div>
                                                                                    <div class="TransportationServiceContent2DivTS">
                                                                                        <small class="TransportationServiceHeading2TS">Location</small>
                                                                                        <small class="TransportationServiceValues">{datatemporary?.location}</small>
                                                                                    </div>
                                                                                    <div class="TransportationServiceContent3DivTS">
                                                                                        <small class="TransportationServiceHeading3">Responded On</small>
                                                                                        <small class="TransportationServiceValues">{FormatTimeStamp(datatemporary?.respondedOn).timedateToLocale}</small>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="TransportationServiceRow2Div">
                                                                                    <div class="TransportationServiceContentDivTS">
                                                                                        <small class="TransportationServiceHeading">Quoted Price</small>
                                                                                        <small class="TransportationServiceValues">R {datatemporary?.quotationAmount}</small>
                                                                                    </div>
                                                                                    <div class="TransportationServiceContentDivTS">
                                                                                        <small class="TransportationServiceHeading">Status</small>
                                                                                        <small class={datatemporary?.quotationStatus === "Open" || datatemporary?.quotationStatus === "Accepted" ? "TransportationServiceValuesGreen" : "TransportationServiceValuesRed"}>{datatemporary?.quotationStatus}</small>
                                                                                    </div>
                                                                                    <div class="TransportationServiceContentDivTS">
                                                                                        <small class="TransportationServiceHeadingRating">Rating</small>
                                                                                        <div class="TransportationServiceRatingsStarDiv">
                                                                                            <img src={datatemporary?.rating >= 1 ? filledStar : blankStar} id="TransportationServiceRatingsStarImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                                                            <img src={datatemporary?.rating >= 2 ? filledStar : blankStar} id="TransportationServiceRatingsStarImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                                                            <img src={datatemporary?.rating >= 3 ? filledStar : blankStar} id="TransportationServiceRatingsStarImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                                                            <img src={datatemporary?.rating >= 4 ? filledStar : blankStar} id="TransportationServiceRatingsStarImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                                                            <img src={datatemporary?.rating >= 5 ? filledStar : blankStar} id="TransportationServiceRatingsStarImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="rightOut1DivTransportationService">
                                                                                <img src={rightarrow} id="rightArrowImgTransportationService" height="16" width="16" class="" alt="" loading="lazy" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>);
                                                    }))}
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                {this.state.showServiceDetails ?
                                                    <div>
                                                        <div class={this.state.showServiceDetailsWithoutCancelRequest ? "TransportationServiceLessRCardcss" : "TransportationServiceRCardcss"}>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Pickup Location</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.pickupLocation}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Destination</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.destination}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Service Window Start Date & Time</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.serviceWindowStartDateTime}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Service Window End Date & Time</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.serviceWindowEndDateTime}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">No. of Containers</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.NoOfContainers}</div>
                                                                <small class="TransportationServiceRInpHeading">
                                                                    <small class="TransportationServiceContainerRed" onClick={this.getContainerDetails}>Click Here</small> to visit Container Details</small>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Commodity</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.commodity}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Truck Type Requirements</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.truckTypeRequirements}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Payment Terms</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.paymentTerms}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Request Closing Date</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.RFQClosingDate}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Special Instructions (Optional)</small>
                                                                <div class="TransportationServiceRLowerText">{this.state.specialInstructions}</div>
                                                            </div>
                                                            <div class="TransportationServiceRInpSize">
                                                                <small id="TransportationServiceRInpHeading">Update Reference Documents (Optional)</small>
                                                                {(!this.state.ApiServiceRequestData?.serviceRequestData?.upload_documents) ?
                                                                    <div class="TransportationServiceNoDocU">No document uploaded</div> :
                                                                    <div class="TransportationServiceRUploaddocText">{this.state.ApiServiceRequestData?.serviceRequestData?.upload_documents?.split('/')[11]?.split("'")[0]}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.showServiceDetailsWithoutCancelRequest &&
                                                            <div>
                                                                <div class="TransportationServiceLessRCardcss">
                                                                    <div class="TransportationServiceRInpSize">
                                                                        <small id="TransportationServiceRInpHeading">Proof of Delivery (Optional)</small>
                                                                        <div className="pass-wrapper" id="TransportationServiceRInpDiv" >
                                                                            <UploadFile uploaddivid="uploadTransportationServiceDeliveryDocuments" idupload="upload"
                                                                                name="fileupload"
                                                                                fileType="jpeg, jpg, png, pdf"
                                                                                setUploadConfirm={this.uploadFileFunction}
                                                                                removeLink={this.removeTransportationServiceDeliveryDocumentsLink}
                                                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                                                setFileLink={this.setUploadLinkTransportationServiceDeliveryDocuments}
                                                                                setLoader={this.setLoaderTransportationServiceDeliveryDocuments}
                                                                                staticFileName={'Delivery_Documents.'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="TransportServiceNoteValue">
                                                                    <small id="TransportationServiceNote">In case of no action, your request will be auto-completed after 7 days.</small>
                                                                </div>
                                                                <div class="TransportServiceRBtnDiv">
                                                                    <Button class="TransportServiceRBtnCss" onClick={this.handleCompleteRequest}>
                                                                        <small class="TransportServiceRBtntext">Complete Request</small>
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="notifooter01TransportationService">
                    <Footer />
                </div>
                <div class="notifooter02TransportationService">
                    <Footer2 />
                </div>
                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="cancelTransportationServiceDiv">
                            <small class="transportationServiceText">{Message.marketPlace.cancelModalQuery}</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'>If you have already made the payment the refund</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'> will be initiated based on the cancellation policy.</small>
                            <small class="transportationServiceTextSmall" id='transportationMobile'>{Message.marketPlace.cancelModalNote}</small>
                        </div>
                    </div>
                </CancelModal>
                <StarRatingModal hasOpen={this.state.hasOpenRating} onCloseModal={() => this.onSumbitRating()}>
                    <div class="TSRatingInpModalDivOut">
                        <div class="TSRatingInpModalHeadDiv">
                            <small class="TSRatingInpModalHeadsm">{Message.marketPlace.starRatingModalRateQuery}</small>
                        </div>
                        <div class="TSRatingInpModalLowerSectionDiv">
                            <div class="TSRatingInpModalNameHeadingDiv">
                                <small class="TSRatingInpModalNameHeading">{Message.marketPlace.starRatingModalCompanyName}</small>
                            </div>
                            <div class="TSRatingInpModalImgDiv">
                                <div class="TSRatingInpModalImgDivin">
                                    {[1, 1, 1, 1, 1].map((item, index) => (
                                        <div class="TSRatingInpModalmodalimgposition"
                                            onClick={() => this.updateRating(index)}
                                            key={index}
                                        >
                                            <img src={index < this.state.ratingStar ? bigFilledStar : bigBlankStar} class="TSRatingInpModalImgStar" height="26" width="26" alt="" loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                                <div className="TSRatingInpModalstarunfillerror">{this.state.errorStarReason}</div>
                            </div>
                        </div>
                        <div class="rejectMainDiv" id="TSRatingRejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your comment"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <div className="QuotationDetailsDropError">{this.state.errors["Comment"]}</div>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </StarRatingModal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(TransportationService);